import { render } from "./ConflictStudents.vue?vue&type=template&id=b1c3675e&scoped=true"
import script from "./ConflictStudents.vue?vue&type=script&lang=js"
export * from "./ConflictStudents.vue?vue&type=script&lang=js"

import "./ConflictStudents.vue?vue&type=style&index=0&id=b1c3675e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c3675e"]])

export default __exports__